import { render, staticRenderFns } from "./Serp.vue?vue&type=template&id=dbec9b8e"
import script from "./Serp.vue?vue&type=script&lang=js"
export * from "./Serp.vue?vue&type=script&lang=js"
import style0 from "./Serp.vue?vue&type=style&index=0&id=dbec9b8e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports